// As roles do token chegam como texto (uma) ou lista (várias).
export var possuiRole = function (roles, role) {
    return Array.isArray(roles) ? roles.includes(role) : roles === role;
};
export var ROLE_DESAFIOS = 'JogadorBiblioteca';
